import React, { useState } from "react";
import {
    Card,
    CardBody,
    Button,
    Row,
    Col,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane
} from "reactstrap";
import classnames from "classnames";
import { FaMapMarkerAlt, FaPhone } from "react-icons/fa";
import logo from "../../../src/assets/images/1505751_LogoR_75_75.jpg";
import agentPhoto1 from "../../../src/assets/images/agent1.jpg";
// import agentPhoto2 from "../../../src/assets/images/agent2.jpg";
import agentDefault from "../../../src/assets/images/defaultagent.png";
import agentproperty1 from "../../../src/assets/images/agentproperty1.jpg";
import { useParams } from 'react-router-dom';

const AgentsDetails = () => {
    const [activeTab, setActiveTab] = useState("1");
    const { title } = useParams(); // Moved inside the component

    const toggleTab = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    return (
        <div className="container my-5">

            {/* Top Card */}

            {/* Title 1 */}
            {title === "Mahesh-Sunfin-Realty" && (
                <Card className="mb-4 p-4 shadow-lg border-0 rounded-4" style={{ marginTop: '13%', background: 'linear-gradient(to right, #fde4e4, #d4f1f9)' }}>
                    <Row className="align-items-center">
                        <Col md="3" className="text-center d-flex flex-column align-items-center">
                            <div
                                className="rounded-4 p-2"
                                style={{
                                    border: '4px solid transparent',
                                    background: 'linear-gradient(white, white) padding-box, linear-gradient(to bottom, #ff9a9e, #00c9ff) border-box',
                                    width: '100%',
                                }}
                            >
                                <img
                                    src={agentPhoto1}
                                    alt="Agent"
                                    className="img-fluid rounded-3 mb-3"
                                    style={{ width: '100%' }}
                                />
                                <div className="bg-white py-3 d-flex justify-content-center">
                                    <img
                                        src={agentproperty1}
                                        alt="Agent Logo"
                                        className="img-fluid"
                                        style={{ width: '50%' }}
                                    />
                                </div>
                            </div>

                            <Button
                                color="danger"
                                className="mt-4 w-75"
                                style={{
                                    borderRadius: '999px',
                                    fontWeight: 'bold',
                                    fontSize: '16px',
                                }}
                            >
                                Contact Agent
                            </Button>
                        </Col>

                        <Col md="9">
                            <h3 className="fw-bold text-dark mb-1">Mahesh</h3>
                            <p className="text-muted mb-4" style={{ fontSize: '16px' }}>
                                <strong>Sunfin Realty Pvt. Ltd.</strong> • Operating since 2009
                            </p>

                            <Row className="mb-3">
                                <Col md="4" className="text-center">
                                    <h5 className="fw-bold text-dark mb-1">118</h5>
                                    <p className="text-muted">Properties For Sale</p>
                                </Col>
                                <Col md="4" className="text-center">
                                    <h5 className="fw-bold text-dark mb-1">34</h5>
                                    <p className="text-muted">Properties For Rent</p>
                                </Col>
                                <Col md="4" className="text-center">
                                    <h5 className="fw-bold text-dark mb-1">450</h5>
                                    <p className="text-muted">Deals Closed</p>
                                </Col>
                            </Row>

                            <div className="mb-2">
                                <span className="fw-bold text-dark">Deals in:</span>
                                <span className="text-muted ms-2">
                                    Rent/Lease, Pre-launch, Original Booking, Resale, Others
                                </span>
                            </div>

                            <div>
                                <span className="fw-bold text-dark">Operates in:</span><br />
                                <span className="text-muted ms-2">
                                    Gotri, Sevasi, Dabhoi Road, Atladara, Vasna Bhayli Main Road, Ellora Park,<br />
                                    Jetalpur, Alkapuri, Sama Savli Road, Sun Pharma Road, Subhanpura, Nizampura,<br />
                                    Vasna Road, Manjalpur, Tarsali, Old Padra Road, Akota, Diwalipura,<br />
                                    Waghodia Road, Dandia Bazar, Sarabhai Road, New Alkapuri, Race Course Road, Chhani,<br />
                                    Karelibaug, New Kareli Baug, Makar Pura, Kalali, Sama, Gotri Sevasi Road,<br />
                                    Pratapgunj, VIP Road, Sayajigunj, New Sama Road, Harni, Soma Talav,<br />
                                    Muj Mahuda, Gotri Road, Gotri, Mujmahuda, Race Course circle, Sama Road,<br />
                                    Ajwa Road

                                </span>
                            </div>

                        </Col>
                    </Row>
                </Card>
            )}

            {/* Title 2 */}
            {title === "Kalpana-Patil-Kalpana-Property" && (
                <Card className="mb-4 p-4 shadow-lg border-0 rounded-4" style={{ marginTop: '13%', background: 'linear-gradient(to right, #fde4e4, #d4f1f9)' }}>
                    <Row className="align-items-center">
                        <Col md="3" className="text-center d-flex flex-column align-items-center">
                            <div
                                className="rounded-4 p-2"

                            >
                                <img
                                    src={agentDefault}
                                    alt="Agent"
                                    className="img-fluid rounded-3 mb-3"
                                    style={{ width: '100%' }}
                                />

                            </div>

                            <Button
                                color="danger"
                                className="mt-4 w-75"
                                style={{
                                    borderRadius: '999px',
                                    fontWeight: 'bold',
                                    fontSize: '16px',
                                }}
                            >
                                Contact Agent
                            </Button>
                        </Col>

                        <Col md="9">
                            <h3 className="fw-bold text-dark mb-1">Kamlesh Patil</h3>
                            <p className="text-muted mb-4" style={{ fontSize: '16px' }}>
                                <strong>Kalpana Property                            <br />
                                    RERA ID: <br />AG/GJ/VADODARA/VADODARA/OTHERS/AA01540/040526R1.<br /></strong> • Operating since 2016
                            </p>

                            <Row className="mb-3">
                                <Col md="4" className="text-center">
                                    <h5 className="fw-bold text-dark mb-1">5</h5>
                                    <p className="text-muted">Properties For Sale</p>
                                </Col>
                                <Col md="4" className="text-center">
                                    <h5 className="fw-bold text-dark mb-1">91</h5>
                                    <p className="text-muted">Properties For rent</p>
                                </Col>
                            </Row>

                            <div className="mb-2">
                                <span className="fw-bold text-dark">Deals in:</span>
                                <span className="text-muted ms-2">
                                    Rent/Lease, Pre-launch, Original Booking, Resale, Others
                                </span>
                            </div>

                            <div>
                                <span className="fw-bold text-dark">Operates in:</span><br />
                                <span className="text-muted ms-2">
                                    Gotri, Sevasi, Dabhoi Road, Atladara, Vasna Bhayli Main Road, Ellora Park,<br />
                                    Jetalpur, Alkapuri, Sama Savli Road, Sun Pharma Road, Subhanpura, Nizampura,<br />
                                    Vasna Road, Manjalpur, Tarsali, Old Padra Road, Akota, Diwalipura,<br />
                                    Waghodia Road, Dandia Bazar, Sarabhai Road, New Alkapuri, Race Course Road, Chhani,<br />
                                    Karelibaug, New Kareli Baug, Makar Pura, Kalali, Sama, Gotri Sevasi Road,<br />
                                    Pratapgunj, VIP Road, Sayajigunj, New Sama Road, Harni, Soma Talav,<br />
                                    Muj Mahuda, Gotri Road, Gotri, Mujmahuda, Race Course circle, Sama Road,<br />
                                    Ajwa Road

                                </span>
                            </div>

                        </Col>
                    </Row>
                </Card>
            )}

            {title === "Priya-Shah-Dream-Home" && (
                <Card className="mb-4 p-4 shadow-lg border-0 rounded-4" style={{ marginTop: '13%', background: 'linear-gradient(to right, #fde4e4, #d4f1f9)' }}>
                    <Row className="align-items-center">
                        <Col md="3" className="text-center d-flex flex-column align-items-center">
                            <div
                                className="rounded-4 p-2"

                            >
                                <img
                                    src={agentDefault}
                                    alt="Agent"
                                    className="img-fluid rounded-3 mb-3"
                                    style={{ width: '100%' }}
                                />

                            </div>

                            <Button
                                color="danger"
                                className="mt-4 w-75"
                                style={{
                                    borderRadius: '999px',
                                    fontWeight: 'bold',
                                    fontSize: '16px',
                                }}
                            >
                                Contact Agent
                            </Button>
                        </Col>

                        <Col md="9">
                            <h3 className="fw-bold text-dark mb-1">Priya Shah</h3>
                            <p className="text-muted mb-4" style={{ fontSize: '16px' }}>
                                <strong>Dream Home Estates<br />
                                    RERA ID: <br />AG/GJ/VADODARA/VADODARA/OTHERS/AA01540/040526R1.<br /></strong> • Operating since 2016
                            </p>

                            <Row className="mb-3">
                                <Col md="4" className="text-center">
                                    <h5 className="fw-bold text-dark mb-1">5</h5>
                                    <p className="text-muted">Properties For Sale</p>
                                </Col>
                                <Col md="4" className="text-center">
                                    <h5 className="fw-bold text-dark mb-1">91</h5>
                                    <p className="text-muted">Properties For rent</p>
                                </Col>
                            </Row>

                            <div className="mb-2">
                                <span className="fw-bold text-dark">Deals in:</span>
                                <span className="text-muted ms-2">
                                    Rent/Lease, Pre-launch, Original Booking, Resale, Others
                                </span>
                            </div>

                            <div>
                                <span className="fw-bold text-dark">Operates in:</span><br />
                                <span className="text-muted ms-2">
                                    Gotri, Sevasi, Dabhoi Road, Atladara, Vasna Bhayli Main Road, Ellora Park,<br />
                                    Jetalpur, Alkapuri, Sama Savli Road, Sun Pharma Road, Subhanpura, Nizampura,<br />
                                    Vasna Road, Manjalpur, Tarsali, Old Padra Road, Akota, Diwalipura,<br />
                                    Waghodia Road, Dandia Bazar, Sarabhai Road, New Alkapuri, Race Course Road, Chhani,<br />
                                    Karelibaug, New Kareli Baug, Makar Pura, Kalali, Sama, Gotri Sevasi Road,<br />
                                    Pratapgunj, VIP Road, Sayajigunj, New Sama Road, Harni, Soma Talav,<br />
                                    Muj Mahuda, Gotri Road, Gotri, Mujmahuda, Race Course circle, Sama Road,<br />
                                    Ajwa Road

                                </span>
                            </div>

                        </Col>
                    </Row>
                </Card>
            )}

            {title === "Rakesh-Patel-UrbanNest" && (
                <Card className="mb-4 p-4 shadow-lg border-0 rounded-4" style={{ marginTop: '13%', background: 'linear-gradient(to right, #fde4e4, #d4f1f9)' }}>
                    <Row className="align-items-center">
                        <Col md="3" className="text-center d-flex flex-column align-items-center">
                            <div
                                className="rounded-4 p-2"

                            >
                                <img
                                    src={agentDefault}
                                    alt="Agent"
                                    className="img-fluid rounded-3 mb-3"
                                    style={{ width: '100%' }}
                                />

                            </div>

                            <Button
                                color="danger"
                                className="mt-4 w-75"
                                style={{
                                    borderRadius: '999px',
                                    fontWeight: 'bold',
                                    fontSize: '16px',
                                }}
                            >
                                Contact Agent
                            </Button>
                        </Col>

                        <Col md="9">
                            <h3 className="fw-bold text-dark mb-1">Rakesh Patel</h3>
                            <p className="text-muted mb-4" style={{ fontSize: '16px' }}>
                                <strong>UrbanNest Realty<br />
                                    RERA ID: <br />AG/GJ/VADODARA/VADODARA/OTHERS/AA01540/040526R1.<br /></strong> • Operating since 2016
                            </p>

                            <Row className="mb-3">
                                <Col md="4" className="text-center">
                                    <h5 className="fw-bold text-dark mb-1">5</h5>
                                    <p className="text-muted">Properties For Sale</p>
                                </Col>
                                <Col md="4" className="text-center">
                                    <h5 className="fw-bold text-dark mb-1">91</h5>
                                    <p className="text-muted">Properties For rent</p>
                                </Col>
                            </Row>

                            <div className="mb-2">
                                <span className="fw-bold text-dark">Deals in:</span>
                                <span className="text-muted ms-2">
                                    Rent/Lease, Pre-launch, Original Booking, Resale, Others
                                </span>
                            </div>

                            <div>
                                <span className="fw-bold text-dark">Operates in:</span><br />
                                <span className="text-muted ms-2">
                                    Gotri, Sevasi, Dabhoi Road, Atladara, Vasna Bhayli Main Road, Ellora Park,<br />
                                    Jetalpur, Alkapuri, Sama Savli Road, Sun Pharma Road, Subhanpura, Nizampura,<br />
                                    Vasna Road, Manjalpur, Tarsali, Old Padra Road, Akota, Diwalipura,<br />
                                    Waghodia Road, Dandia Bazar, Sarabhai Road, New Alkapuri, Race Course Road, Chhani,<br />
                                    Karelibaug, New Kareli Baug, Makar Pura, Kalali, Sama, Gotri Sevasi Road,<br />
                                    Pratapgunj, VIP Road, Sayajigunj, New Sama Road, Harni, Soma Talav,<br />
                                    Muj Mahuda, Gotri Road, Gotri, Mujmahuda, Race Course circle, Sama Road,<br />
                                    Ajwa Road

                                </span>
                            </div>

                        </Col>
                    </Row>
                </Card>
            )}


            {/* Tabs */}
            {/* Tabs */}
            <Nav tabs className="mb-4 border-0 py-2 px-3 rounded-3" style={{
                background: 'linear-gradient(to right, rgb(253, 228, 228), rgb(212, 241, 249))'
            }}>
                <NavItem>
                    <NavLink
                        className={classnames({ active: activeTab === "1" })}
                        onClick={() => toggleTab("1")}
                        style={{
                            color: activeTab === "1" ? '#dc3545' : '#666',
                            fontWeight: activeTab === "1" ? 'bold' : 'normal',
                            fontSize: '16px'
                        }}
                    >
                        Overview
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        className={classnames({ active: activeTab === "2" })}
                        onClick={() => toggleTab("2")}
                        style={{
                            color: activeTab === "2" ? '#dc3545' : '#666',
                            fontWeight: activeTab === "2" ? 'bold' : 'normal',
                            fontSize: '16px'
                        }}
                    >
                        About me
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        className={classnames({ active: activeTab === "3" })}
                        onClick={() => toggleTab("3")}
                        style={{
                            color: activeTab === "3" ? '#dc3545' : '#666',
                            fontWeight: activeTab === "3" ? 'bold' : 'normal',
                            fontSize: '16px'
                        }}
                    >
                        Team
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        className={classnames({ active: activeTab === "4" })}
                        onClick={() => toggleTab("4")}
                        style={{
                            color: activeTab === "4" ? '#dc3545' : '#666',
                            fontWeight: activeTab === "4" ? 'bold' : 'normal',
                            fontSize: '16px'
                        }}
                    >
                        Properties for Sale
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        className={classnames({ active: activeTab === "5" })}
                        onClick={() => toggleTab("5")}
                        style={{
                            color: activeTab === "5" ? '#dc3545' : '#666',
                            fontWeight: activeTab === "5" ? 'bold' : 'normal',
                            fontSize: '16px'
                        }}
                    >
                        Properties for Rent
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        className={classnames({ active: activeTab === "6" })}
                        onClick={() => toggleTab("6")}
                        style={{
                            color: activeTab === "6" ? '#dc3545' : '#666',
                            fontWeight: activeTab === "6" ? 'bold' : 'normal',
                            fontSize: '16px'
                        }}
                    >
                        Contact Agent
                    </NavLink>
                </NavItem>
            </Nav>

            {/* Tab Content */}
            <TabContent activeTab={activeTab} className="text-white">
                {title === "Mahesh-Sunfin-Realty" && (
                    <TabPane tabId="1">
                        <Card className="mb-4 p-4 shadow-lg border-0 rounded-4" style={{ background: 'rgba(255, 255, 255, 0.1)' }}>
                            {/* Overview content */}
                            <h5 className="fw-bold border-bottom pb-2 mb-3" style={{ color: '#ffffff', fontSize: '1.5rem' }}>About Sunfin Realty Pvt. Ltd.</h5>
                            <p className="fw-bold" style={{ color: '#ffffff', fontSize: '-1.9rem' }}>
                                Sunfin Realty is an Real Estate Advisory and Transactions Company operating in Vadodara from last 15 years and it has assisted more than 4000 Individual Home Buyers, Investors, Developers, SMEs and Large corporates collectively in assisting to give them best Residential, Commercial, Industrial and Land related Real Estate Transactions according to their requirement.
                            </p>
                            <p className="fw-bold" style={{ color: '#ffffff', fontSize: '-1.9rem' }}>
                                <span style={{ color: '#ff6b6b' }}>Team Size:</span> 18 people<br />
                                <span style={{ color: '#ff6b6b' }}>Address:</span> 407, 4th floor, Dwarkesh Complex, Alkapuri, Vadodara - 390007, Gujarat, India.
                            </p>
                        </Card>
                    </TabPane>
                )}

                <TabPane tabId="2">
                    <Card className="mb-4 p-4 shadow-lg border-0 rounded-4" style={{ background: 'rgba(255, 255, 255, 0.1)' }}>
                        {/* About me content */}
                        <h5 className="fw-bold border-bottom pb-2 mb-3" style={{ color: '#ffffff', fontSize: '1.5rem' }}>About Me</h5>
                        <p className="fw-bold" style={{ color: '#ffffff', fontSize: '-1.9rem' }}>
                            Information about the agent would go here...
                        </p>
                    </Card>
                </TabPane>

                <TabPane tabId="3">
                    <Card className="mb-4 p-4 shadow-lg border-0 rounded-4" style={{ background: 'rgba(255, 255, 255, 0.1)' }}>
                        {/* Team content */}
                        <h5 className="fw-bold border-bottom pb-2 mb-3" style={{ color: '#ffffff', fontSize: '1.5rem' }}>Meet the Team</h5>
                        <p className="fw-bold" style={{ color: '#ffffff', fontSize: '-1.9rem' }}>
                            Team information would go here...
                        </p>
                    </Card>
                </TabPane>

                <TabPane tabId="4">
                    <Card className="mb-4 p-4 shadow-lg border-0 rounded-4" style={{ background: 'rgba(255, 255, 255, 0.1)' }}>
                        {/* Properties for Sale content */}
                        <h5 className="fw-bold border-bottom pb-2 mb-3" style={{ color: '#ffffff', fontSize: '1.5rem' }}>Properties for Sale</h5>
                        <Row>
                            <Col md="4" className="mb-4">
                                <Card className="shadow-sm rounded-3 bg-dark">
                                    <img src={agentproperty1} className="card-img-top" alt="Property" />
                                    <CardBody className="text-white">
                                        <h6 className="fw-bold">₹ 70 Lac • 3944 per sqft</h6>
                                        <p className="mb-1 fw-bold">3 BHK Apartment 1100 sqft</p>
                                        <p className="small" style={{ color: '#cccccc' }}>In Sama</p>
                                        <Button color="danger" size="sm" className="fw-bold">Contact Agent</Button>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col md="4" className="mb-4">
                                <Card className="shadow-sm rounded-3 bg-dark">
                                    <img src={agentproperty1} className="card-img-top" alt="Property" />
                                    <CardBody className="text-white">
                                        <h6 className="fw-bold">₹ 90 Lac • 4090 per sqft</h6>
                                        <p className="mb-1 fw-bold">4 BHK House 2200 sqft</p>
                                        <p className="small" style={{ color: '#cccccc' }}>In Waghodia Road</p>
                                        <Button color="danger" size="sm" className="fw-bold">Contact Agent</Button>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col md="4" className="mb-4">
                                <Card className="shadow-sm rounded-3 bg-dark">
                                    <img src={agentproperty1} className="card-img-top" alt="Property" />
                                    <CardBody className="text-white">
                                        <h6 className="fw-bold">₹ 55 Lac • 4583 per sqft</h6>
                                        <p className="mb-1 fw-bold">2 BHK House 1200 sqft</p>
                                        <p className="small" style={{ color: '#cccccc' }}>In Waghodia Road</p>
                                        <Button color="danger" size="sm" className="fw-bold">Contact Agent</Button>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Card>
                </TabPane>

                <TabPane tabId="5">
                    <Card className="mb-4 p-4 shadow-lg border-0 rounded-4" style={{ background: 'rgba(255, 255, 255, 0.1)' }}>
                        {/* Properties for Rent content */}
                        <h5 className="fw-bold border-bottom pb-2 mb-3" style={{ color: '#ffffff', fontSize: '1.5rem' }}>Properties for Rent</h5>
                        <Row>
                            {[1, 2, 3].map((i) => (
                                <Col md="4" className="mb-4" key={i}>
                                    <Card className="shadow-sm rounded-3 bg-dark">
                                        <img src={agentproperty1} className="card-img-top" alt="Property" />
                                        <CardBody className="text-white">
                                            <h6 className="fw-bold">₹ {i * 10000} Rent • {20 + i} per sqft</h6>
                                            <p className="mb-1 fw-bold">Office Space {500 + i * 100} sqft</p>
                                            <p className="small" style={{ color: '#cccccc' }}>Vadodara • 1 Bath</p>
                                            <Button color="danger" size="sm" className="fw-bold">Contact Agent</Button>
                                        </CardBody>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </Card>
                </TabPane>

                <TabPane tabId="6">
                    <Card className="mb-4 p-4 shadow-lg border-0 rounded-4" style={{ background: 'rgba(255, 255, 255, 0.1)' }}>
                        {/* Contact Agent content */}
                        <h5 className="fw-bold border-bottom pb-2 mb-3" style={{ color: '#ffffff', fontSize: '1.5rem' }}>Contact Agent</h5>
                        <p className="fw-bold" style={{ color: '#ffffff', fontSize: '-1.9rem' }}>
                            Contact form or information would go here...
                        </p>
                    </Card>
                </TabPane>
            </TabContent>
            {/* Inline Styling for tab buttons */}
            <style>
                {`
                .tab-button-custom {
    color: white !important;
    font-weight: 600;
    font-size: 16px;
    padding: 0.75rem 1.5rem;
    background-color: transparent;
    border: none;
    transition: all 0.3s ease;
}

.tab-button-custom:hover {
    color: #fff !important;
    font-weight: 700;
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 0.5rem;
}

.tab-button-custom.active {
    border-bottom: 3px solid white;
    color: #fff !important;
    font-weight: 800;
}

                    .tab-button {
                        color: #666;
                        border: none;
                        padding: 0.75rem 1.5rem;
                        background: transparent;
                        transition: all 0.2s ease-in-out;
                        font-weight: 500;
                    }

                    .tab-button:hofver {
                        color: #dc3545;
                        font-weight: 600;
                    }

                    .tab-button.active {
                        border-bottom: 2px solid #dc3545;
                        color: #dc3545;
                        font-weight: 700;
                    }
                        .agent-photo-card {
  border-radius: 1rem;
  background: linear-gradient(135deg, #ff9a9e 0%, #00c6ff 100%);
  display: inline-block;
}
.agent-photo-card > div {
  border-bottom-left-radius: 1rem;
  border-bottom-right-radius: 1rem;
}

                `}
            </style>
        </div>

    );
};

export default AgentsDetails;
